/**
 * querySchemaData接口的Mock数据
 * 基于API文档和settingPanel.vue中的使用逻辑生成
 */

// 销售事实表的Schema数据
export const mockSalesSchemaData = {
  code: 200,
  message: 'success',
  data: {
    describe: '销售数据概览 - 包含销售金额、数量、利润等关键指标',
    meta: [
      {
        field: 'number',
        name: '数量',
      },
      {
        field: 'province',
        name: '省份',
      },
      {
        field: 'city',
        name: '城市',
      },
      {
        field: 'type',
        name: '类别',
      },
      {
        field: 'sub_type',
        name: '子类别',
      },
    ],
    data: [
      {
        number: 7789,
        province: '浙江省',
        city: '杭州市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 2367,
        province: '浙江省',
        city: '绍兴市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 3877,
        province: '浙江省',
        city: '宁波市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 4342,
        province: '浙江省',
        city: '舟山市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 5343,
        province: '浙江省',
        city: '杭州市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 632,
        province: '浙江省',
        city: '绍兴市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 7234,
        province: '浙江省',
        city: '宁波市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 834,
        province: '浙江省',
        city: '舟山市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 945,
        province: '浙江省',
        city: '杭州市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 1304,
        province: '浙江省',
        city: '绍兴市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 1145,
        province: '浙江省',
        city: '宁波市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 1432,
        province: '浙江省',
        city: '舟山市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 1343,
        province: '浙江省',
        city: '杭州市',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 1354,
        province: '浙江省',
        city: '绍兴市',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 1523,
        province: '浙江省',
        city: '宁波市',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 1634,
        province: '浙江省',
        city: '舟山市',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 1723,
        province: '四川省',
        city: '成都市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 1822,
        province: '四川省',
        city: '绵阳市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 1943,
        province: '四川省',
        city: '南充市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 2330,
        province: '四川省',
        city: '乐山市',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 2451,
        province: '四川省',
        city: '成都市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 2244,
        province: '四川省',
        city: '绵阳市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 2333,
        province: '四川省',
        city: '南充市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 2445,
        province: '四川省',
        city: '乐山市',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 2335,
        province: '四川省',
        city: '成都市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 245,
        province: '四川省',
        city: '绵阳市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 2457,
        province: '四川省',
        city: '南充市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 2458,
        province: '四川省',
        city: '乐山市',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 4004,
        province: '四川省',
        city: '成都市',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 3077,
        province: '四川省',
        city: '绵阳市',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 3551,
        province: '四川省',
        city: '南充市',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 352,
        province: '四川省',
        city: '乐山市',
        type: '办公用品',
        sub_type: '纸张',
      },
    ],
    totalData: [
      {
        number: 26193,
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 49709,
        type: '家具',
      },
      {
        number: 23516,
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 29159,
        type: '办公用品',
      },
      {
        number: 12321,
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 16838,
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 18375,
        province: '浙江省',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 14043,
        province: '浙江省',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 4826,
        province: '浙江省',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 5854,
        province: '浙江省',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 7818,
        province: '四川省',
        type: '家具',
        sub_type: '桌子',
      },
      {
        number: 9473,
        province: '四川省',
        type: '家具',
        sub_type: '沙发',
      },
      {
        number: 7495,
        province: '四川省',
        type: '办公用品',
        sub_type: '笔',
      },
      {
        number: 10984,
        province: '四川省',
        type: '办公用品',
        sub_type: '纸张',
      },
      {
        number: 13132,
        province: '浙江省',
        city: '杭州市',
        type: '家具',
      },
      {
        number: 2288,
        province: '浙江省',
        city: '杭州市',
        type: '办公用品',
      },
      {
        number: 15420,
        province: '浙江省',
        city: '杭州市',
      },
      {
        number: 2999,
        province: '浙江省',
        city: '绍兴市',
        type: '家具',
      },
      {
        number: 2658,
        province: '浙江省',
        city: '绍兴市',
        type: '办公用品',
      },
      {
        number: 5657,
        province: '浙江省',
        city: '绍兴市',
      },
      {
        number: 11111,
        province: '浙江省',
        city: '宁波市',
        type: '家具',
      },
      {
        number: 2668,
        province: '浙江省',
        city: '宁波市',
        type: '办公用品',
      },
      {
        number: 13779,
        province: '浙江省',
        city: '宁波市',
      },
      {
        number: 5176,
        province: '浙江省',
        city: '舟山市',
        type: '家具',
      },
      {
        number: 3066,
        province: '浙江省',
        city: '舟山市',
        type: '办公用品',
      },
      {
        number: 8242,
        province: '浙江省',
        city: '舟山市',
      },
      {
        number: 4174,
        province: '四川省',
        city: '成都市',
        type: '家具',
      },
      {
        number: 6339,
        province: '四川省',
        city: '成都市',
        type: '办公用品',
      },
      {
        number: 10513,
        province: '四川省',
        city: '成都市',
      },
      {
        number: 4066,
        province: '四川省',
        city: '绵阳市',
        type: '家具',
      },
      {
        number: 3322,
        province: '四川省',
        city: '绵阳市',
        type: '办公用品',
      },
      {
        number: 7388,
        province: '四川省',
        city: '绵阳市',
      },
      {
        number: 4276,
        province: '四川省',
        city: '南充市',
        type: '家具',
      },
      {
        number: 6008,
        province: '四川省',
        city: '南充市',
        type: '办公用品',
      },
      {
        number: 10284,
        province: '四川省',
        city: '南充市',
      },
      {
        number: 4775,
        province: '四川省',
        city: '乐山市',
        type: '家具',
      },
      {
        number: 2810,
        province: '四川省',
        city: '乐山市',
        type: '办公用品',
      },
      {
        number: 7585,
        province: '四川省',
        city: '乐山市',
      },
      {
        number: 32418,
        province: '浙江省',
        type: '家具',
      },
      {
        number: 10680,
        province: '浙江省',
        type: '办公用品',
      },
      {
        number: 43098,
        province: '浙江省',
      },
      {
        number: 17291,
        province: '四川省',
        type: '家具',
      },
      {
        number: 18479,
        province: '四川省',
        type: '办公用品',
      },
      {
        number: 35770,
        province: '四川省',
      },
      {
        number: 78868,
      },
    ],
  },
}

// 订单事实表的Schema数据
export const mockOrderSchemaData = {
  code: 200,
  message: 'success',
  data: {
    describe: '订单数据概览 - 包含订单金额、数量、运费、税费等关键指标',
    meta: [
      {
        field: 'order_amount',
        name: '订单金额',
      },
      {
        field: 'order_quantity',
        name: '订单数量',
      },
      {
        field: 'shipping_cost',
        name: '运费',
      },
      {
        field: 'tax_amount',
        name: '税费',
      },
      {
        field: 'order_date',
        name: '订单日期',
      },
      {
        field: 'order_status',
        name: '订单状态',
      },
      {
        field: 'customer_level',
        name: '客户等级',
      },
      {
        field: 'order_type',
        name: '订单类型',
      },
      {
        field: 'payment_method',
        name: '支付方式',
      },
    ],
    data: [
      {
        order_amount: 2500.00,
        order_quantity: 5,
        shipping_cost: 50.00,
        tax_amount: 125.00,
        order_date: '2023-01-15',
        order_status: '已完成',
        customer_level: 'VIP',
        order_type: '线上订单',
        payment_method: '支付宝',
      },
      {
        order_amount: 1800.50,
        order_quantity: 3,
        shipping_cost: 30.00,
        tax_amount: 90.03,
        order_date: '2023-01-16',
        order_status: '配送中',
        customer_level: '普通',
        order_type: '线上订单',
        payment_method: '微信支付',
      },
      {
        order_amount: 3200.75,
        order_quantity: 8,
        shipping_cost: 0.00,
        tax_amount: 160.04,
        order_date: '2023-01-17',
        order_status: '已完成',
        customer_level: 'VIP',
        order_type: '线下订单',
        payment_method: '现金',
      },
      {
        order_amount: 950.25,
        order_quantity: 2,
        shipping_cost: 25.00,
        tax_amount: 47.51,
        order_date: '2023-01-18',
        order_status: '待发货',
        customer_level: '普通',
        order_type: '线上订单',
        payment_method: '银行卡',
      },
      {
        order_amount: 4500.80,
        order_quantity: 12,
        shipping_cost: 80.00,
        tax_amount: 225.04,
        order_date: '2023-01-19',
        order_status: '已完成',
        customer_level: '高级',
        order_type: '线上订单',
        payment_method: '支付宝',
      }
    ]
  }
}

// 用户行为事实表的Schema数据
export const mockUserBehaviorSchemaData = {
  code: 200,
  message: 'success',
  data: {
    describe: '用户行为数据概览 - 包含页面浏览量、点击次数、停留时长、跳出率等关键指标',
    meta: [
      {
        field: 'page_views',
        name: '页面浏览量',
      },
      {
        field: 'click_count',
        name: '点击次数',
      },
      {
        field: 'duration',
        name: '停留时长',
      },
      {
        field: 'bounce_rate',
        name: '跳出率',
      },
      {
        field: 'behavior_date',
        name: '行为日期',
      },
      {
        field: 'user_segment',
        name: '用户分群',
      },
      {
        field: 'user_level',
        name: '用户等级',
      },
      {
        field: 'behavior_type',
        name: '行为类型',
      },
      {
        field: 'device_type',
        name: '设备类型',
      },
    ],
    data: [
      {
        page_views: 1250,
        click_count: 320,
        duration: 180.5,
        bounce_rate: 0.25,
        behavior_date: '2023-01-15',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '浏览',
        device_type: 'PC',
      },
      {
        page_views: 890,
        click_count: 450,
        duration: 245.8,
        bounce_rate: 0.15,
        behavior_date: '2023-01-16',
        user_segment: '老用户',
        user_level: 'VIP',
        behavior_type: '点击',
        device_type: '移动端',
      },
      {
        page_views: 2100,
        click_count: 680,
        duration: 320.2,
        bounce_rate: 0.08,
        behavior_date: '2023-01-17',
        user_segment: '老用户',
        user_level: '高级',
        behavior_type: '购买',
        device_type: 'PC',
      },
      {
        page_views: 1560,
        click_count: 420,
        duration: 195.6,
        bounce_rate: 0.22,
        behavior_date: '2023-01-18',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '浏览',
        device_type: '平板',
      },
      {
        page_views: 980,
        click_count: 280,
        duration: 165.3,
        bounce_rate: 0.18,
        behavior_date: '2023-01-19',
        user_segment: '老用户',
        user_level: 'VIP',
        behavior_type: '搜索',
        device_type: '移动端',
      },
      {
        page_views: 1350,
        click_count: 380,
        duration: 220.7,
        bounce_rate: 0.12,
        behavior_date: '2023-01-20',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '浏览',
        device_type: 'PC',
      },
      {
        page_views: 1680,
        click_count: 520,
        duration: 280.4,
        bounce_rate: 0.09,
        behavior_date: '2023-01-21',
        user_segment: '老用户',
        user_level: '高级',
        behavior_type: '购买',
        device_type: '移动端',
      },
      {
        page_views: 1120,
        click_count: 340,
        duration: 195.2,
        bounce_rate: 0.21,
        behavior_date: '2023-01-22',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '点击',
        device_type: '平板',
      },
      {
        page_views: 1980,
        click_count: 620,
        duration: 310.8,
        bounce_rate: 0.07,
        behavior_date: '2023-01-23',
        user_segment: '老用户',
        user_level: 'VIP',
        behavior_type: '购买',
        device_type: 'PC',
      },
      {
        page_views: 1450,
        click_count: 410,
        duration: 240.6,
        bounce_rate: 0.14,
        behavior_date: '2023-01-24',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '浏览',
        device_type: '移动端',
      },
      {
        page_views: 820,
        click_count: 260,
        duration: 155.9,
        bounce_rate: 0.19,
        behavior_date: '2023-01-25',
        user_segment: '老用户',
        user_level: '普通',
        behavior_type: '搜索',
        device_type: '平板',
      },
      {
        page_views: 1750,
        click_count: 580,
        duration: 295.3,
        bounce_rate: 0.11,
        behavior_date: '2023-01-26',
        user_segment: '老用户',
        user_level: '高级',
        behavior_type: '购买',
        device_type: 'PC',
      },
      {
        page_views: 1280,
        click_count: 390,
        duration: 210.5,
        bounce_rate: 0.16,
        behavior_date: '2023-01-27',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '点击',
        device_type: '移动端',
      },
      {
        page_views: 920,
        click_count: 290,
        duration: 170.8,
        bounce_rate: 0.17,
        behavior_date: '2023-01-28',
        user_segment: '老用户',
        user_level: 'VIP',
        behavior_type: '搜索',
        device_type: '平板',
      },
      {
        page_views: 1620,
        click_count: 510,
        duration: 275.2,
        bounce_rate: 0.10,
        behavior_date: '2023-01-29',
        user_segment: '老用户',
        user_level: '高级',
        behavior_type: '购买',
        device_type: 'PC',
      },
      {
        page_views: 1380,
        click_count: 420,
        duration: 225.7,
        bounce_rate: 0.13,
        behavior_date: '2023-01-30',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '浏览',
        device_type: '移动端',
      },
      {
        page_views: 1050,
        click_count: 320,
        duration: 185.4,
        bounce_rate: 0.20,
        behavior_date: '2023-01-31',
        user_segment: '老用户',
        user_level: '普通',
        behavior_type: '点击',
        device_type: '平板',
      },
      {
        page_views: 1890,
        click_count: 600,
        duration: 305.1,
        bounce_rate: 0.08,
        behavior_date: '2023-02-01',
        user_segment: '老用户',
        user_level: 'VIP',
        behavior_type: '购买',
        device_type: 'PC',
      },
      {
        page_views: 1150,
        click_count: 350,
        duration: 200.3,
        bounce_rate: 0.15,
        behavior_date: '2023-02-02',
        user_segment: '新用户',
        user_level: '普通',
        behavior_type: '浏览',
        device_type: '移动端',
      },
    ]
  }
}

/**
 * 根据faceTableCode返回对应的Mock数据
 */
export const getMockSchemaData = (faceTableCode) => {
  const mockDataMap = {
    'SALES_FACT': mockSalesSchemaData,
    'ORDER_FACT': mockOrderSchemaData,
    'USER_BEHAVIOR_FACT': mockUserBehaviorSchemaData
  }
  
  return mockDataMap[faceTableCode] || mockSalesSchemaData
}

/**
 * 模拟querySchemaData接口调用
 * 可以直接替换原有的接口调用
 */
export const mockQuerySchemaData = async (params = {}, options = {}) => {
  // 模拟网络延迟
  await new Promise(resolve => setTimeout(resolve, 800))
  
  const { faceTableCode } = params
  const mockResponse = getMockSchemaData(faceTableCode)
  
  return {
    data: mockResponse.data
  }
}

/**
 * 在settingPanel.vue中使用的格式
 * 经过数据处理后的数据结构
 */
export const getMockSchemaDataProcessed = (faceTableCode) => {
  const mockResponse = getMockSchemaData(faceTableCode)
  const { data, fields, describe } = mockResponse.data
  
  // 处理数值字段，保留两位小数
  const processedData = data.map(item => {
    const processedItem = { ...item }
    fields.values.forEach(field => {
      if (processedItem[field] && typeof processedItem[field] === 'number') {
        processedItem[field] = Number(processedItem[field].toFixed(2))
      }
    })
    return processedItem
  })
  
  return {
    describe,
    fields,
    data: processedData
  }
}
